import request from '../../request';
import { URL } from '../../../constants/reading/ApiConstants';
import { constructUrlObject } from '../../../utils/shared/urlUtils';
import { PARAM } from '../../../constants/shared/ApiConstants';

const { D8_RESULT_URL, D8_INVALIDATE_RESULTS_URL } = URL;

class D8Client {
    static getResultById = resultId => request.get(`${D8_RESULT_URL}/${resultId}`);

    static invalidateResult = getResultToInvalidateFromStore => {
        const resultToInvalidate = getResultToInvalidateFromStore();
        return request.put(`${D8_RESULT_URL}/${resultToInvalidate.result_id}`, {
            ...resultToInvalidate,
            is_valid: false,
        });
    };

    static invalidateSecondAttemptResults = (schoolYear, studentId) => {
        return request.delete(
            constructUrlObject(`${D8_INVALIDATE_RESULTS_URL}`, {
                [PARAM.SCHOOL_YEAR]: schoolYear,
                [PARAM.STUDENT_UID]: studentId,
            }),
        );
    };
}

export default D8Client;
